import React from 'react';
import PlainPageHeading, { PlainPageHeadingContext } from 'components/plain_page_heading';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Link from 'components/link';
import Text from 'components/text';
import { AppUI } from '@seedlang/state';

const DEFAULT_BACKGROUND = 'linear-gradient(-134deg,#3BD7C5 0%,#0DAFF6 100%)';

export const FaqContentWrapper = styled.div`
  padding-bottom: 100px;
`;

const Wrapper = styled.div`
  margin: ${props => props.margin};
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  padding: 10px;
  align-items: center;
  height: 100px;
  justify-content: center;
`;

const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlainBreadcrumbs = styled(PlainPageHeading)`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  a {
    color: inherit;
    text-decoration: underline;
  }
`;

const Title = styled.div`
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-right: 4px;
    width: 16px;
  }
`;

@observer
class FaqHeader extends React.Component {

  static contextType = PlainPageHeadingContext;

  background() {
    return AppUI.siteIsSeedlang ? DEFAULT_BACKGROUND : AppUI.site.accentColor;
  }

  render() {
    if (this.context) {
      if (this.props.currentRoute === 'help_center') {
        return <PlainPageHeading>Help Center</PlainPageHeading>;
      }

      return (
        <>
          <nav aria-label='Help Center breadcrumbs'>
            <PlainBreadcrumbs contentGap={this.props.title ? 20 : 30}>
              <Link to='help_center'>Help Center</Link>
              {this.props.faqCategoryName && (
                <>
                  <span aria-hidden='true'>/</span>
                  {this.props.currentRoute === 'faq_categories.show' ? (
                    <span aria-current='page'>{this.props.faqCategoryName}</span>
                  ) : (
                    <Link to={{name: 'faq_categories.show', params: {faqCategoryId: this.props.faqCategoryId}}}>
                      {this.props.faqCategoryName}
                    </Link>
                  )}
                </>
              )}
            </PlainBreadcrumbs>
          </nav>
          {this.props.title && <PlainPageHeading>{this.props.title}</PlainPageHeading>}
        </>
      );
    }

    return (
      <Wrapper
        margin={this.props.margin}
        background={this.background()}
      >
        <LinksWrapper>
          {
            this.props.currentRoute === 'help_center' &&
              <Text
                color='#FFF'
                bold
                fontSize='20px'
                lineHeight='24px'
              >
                Help Center
              </Text>
          }
          {
            this.props.currentRoute !== 'help_center' &&
              <Link to='help_center'>
                <Text
                  color='#FFF'
                  bold
                  underline
                  fontSize='20px'
                  lineHeight='24px'
                >
                  Help Center
                </Text>
              </Link>
          }
          {
            this.props.currentRoute !== 'help_center' &&
              <Text
                color='#FFF'
                bold
                fontSize='20px'
                lineHeight='24px'
              >
                &nbsp;/&nbsp;
              </Text>
          }
          {
            this.props.currentRoute === 'faq_categories.show' && this.props.faqCategoryName &&
              <TextWrapper>
                <Text
                  color='#FFF'
                  bold
                  fontSize='20px'
                  lineHeight='24px'
                >
                  {this.props.faqCategoryName}
                </Text>
              </TextWrapper>
          }
          {
            this.props.currentRoute !== 'faq_categories.show' && this.props.faqCategoryName &&
              <Link
                to={{name: 'faq_categories.show', params: {faqCategoryId: this.props.faqCategoryId}}}
              >
                <TextWrapper>
                  <Text
                    color='#FFF'
                    bold
                    underline
                    fontSize='20px'
                    lineHeight='24px'
                  >
                    {this.props.faqCategoryName}
                  </Text>
                </TextWrapper>
              </Link>
          }
        </LinksWrapper>
        <Title>
          <Text
            bold
            fontSize='28px'
            lineHeight='32px'
            margin='5px 0 0 0'
            color='#FFF'
          >
            {this.props.title}
          </Text>
        </Title>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(FaqHeader);
